import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export function ShowMore({ items, render, initial = 5, testid, className = "divide-y divide-gray-50" }) {
  const [all, setAll] = useState(false);
  const shown = all ? items : items.slice(0, initial);
  return (
    <>
      <div className={className}>{shown.map(render)}</div>
      {items.length > initial && (
        <button type="button" onClick={() => setAll(!all)} data-testid={`${testid}-toggle`}
          className="mt-2 flex w-full items-center justify-center gap-1 rounded-full py-2 text-xs font-semibold text-[#065F46] transition-colors hover:bg-emerald-50">
          {all ? "Réduire" : `Voir tout (${items.length})`}<ChevronDown className={`h-3.5 w-3.5 transition-transform ${all ? "rotate-180" : ""}`} />
        </button>)}
    </>
  );
}

export function JumpBar({ sections }) {
  return (
    <div className="sticky top-[69px] z-10 -mx-1 md:top-0 flex gap-2 overflow-x-auto bg-[#FAFAF7]/90 px-1 py-2 backdrop-blur" data-testid="enc-jumpbar">
      {sections.map(([id, label, n]) => (
        <a key={id} href={`#${id}`} onClick={(e) => { e.preventDefault(); document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
          data-testid={`jump-${id}`} className="shrink-0 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-600 transition-colors hover:border-[#065F46] hover:text-[#065F46]">
          {label}{n != null && <span className="ml-1 text-gray-400">{n}</span>}
        </a>))}
    </div>
  );
}
